import React, { useEffect, useRef } from "react";
import "./AdHorizontalBanner.css";

/**
 * 애드센스 광고 배너
 * @returns {Element}
 * @constructor
 */
const AdHorizontalBanner = () => {
  const adRef = useRef(null);
  useEffect(() => {
    if (window.adsbygoogle && adRef.current) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        console.log(e);
      }
    }
  }, []);

  return (
    <div className="ad-horizontal-banner-container">
      <ins
        className="adsbygoogle ad-horizontal-banner-ins"
        data-ad-client="ca-pub-1705107311727286"
        data-ad-slot="4825538968"
        ref={adRef}
      />
    </div>
  );
};

export default AdHorizontalBanner;
